import React, { useState } from 'react';

const Creategooglekeep = (props) => {
  const [expand, setExpand] = useState(false);
  const [note, setNote] = useState({
    title: '',
    content:'',
  })
  const InputEvent = (event) =>{
    // const value = event.target.value;
    // const name = event.target.name;
    
    const {name,value} = event.target;
    setNote((prevData) =>{
      return{
        ...prevData,
        [name]: value,
      }
    })
  }
  const addEvent = () =>{
     props.passNote(note);
     setNote (() => {
       return ({
        title: '',
        content:'',
      })
     })
  }

  const expandIt = () => {
    setExpand(true);
  }
  
  const backtoNormal = () => {
    setExpand(false);
  }

  const onSubmit = (event) => {
    event.preventDefault();
}

  return (
  <>
  <div className='card text-center'>
  <div className='p-5'>
    <form onSubmit={onSubmit}>
    {expand ? (
      <input className='form-control mb-4' 
      name='title' type="text" 
      value={note.title} 
      onChange={InputEvent} 
      placeholder='title' 
      autoComplete='off' /> ) :null}
      <textarea 
      className='form-control mb-4' 
      name='content' 
      value={note.content} 
      onChange={InputEvent} 
      placeholder='Write Content'
      onClick={expandIt}
      onDoubleClick={backtoNormal} ></textarea>
      {expand ? (
      <button className='btn btn-primary' onClick={addEvent}>Add</button>) :null}
    </form>
    </div>
  </div>
  </>);
};

export default Creategooglekeep;
